/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Draft_NoticeInputs */

const da_legal_draft_notice = /** @type {(inputs: Legal_Draft_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udkast – teksten er endnu ikke gældende.`)
};

/** @type {(inputs: Legal_Draft_NoticeInputs) => LocalizedString} */
const en_legal_draft_notice = da_legal_draft_notice;

/**

* @param {Legal_Draft_NoticeInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_draft_notice = /** @type {((inputs?: Legal_Draft_NoticeInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Draft_NoticeInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_draft_notice(inputs)
	return /** @type {LocalizedString} */ ("Udkast – teksten er endnu ikke gældende.")
});